<script setup lang="ts">
import PromocodePage from '@/components/promocode/Page.vue';
import useSeo from '@/composables/useSeo';
import { getStandardSeoSuffixes } from '@/utils/seoConstants';

const { standardTitleSuffix } = getStandardSeoSuffixes();

useSeo({
  title: `Promocode ${standardTitleSuffix}`,
});
</script>

<template>
  <PromocodePage />
</template>
